import { render, staticRenderFns } from "./students-access.vue?vue&type=template&id=720c97be&scoped=true&"
import script from "./students-access.vue?vue&type=script&lang=js&"
export * from "./students-access.vue?vue&type=script&lang=js&"
import style0 from "./students-access.vue?vue&type=style&index=0&id=720c97be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720c97be",
  null
  
)

export default component.exports